import axios from 'axios';

import { SaveShowingAgentDto } from '../interfaces/save-showing-agent.dto';
import { ShowingAgentDto } from '../interfaces/showing-agent.dto';

class ShowingAgentsService {
  async getList() {
    const response = await axios.get<ShowingAgentDto[]>('showing-agents');

    return response.data;
  }

  async create(payload: SaveShowingAgentDto) {
    const response = await axios.post<ShowingAgentDto>('showing-agents', payload);

    return response.data;
  }
}

export default new ShowingAgentsService();
